import { FolderExplorerContainer } from 'components/folder/explorer/folder-explorer-styles';
import { SubnavContainer_s } from 'components/subnav/subnav-styles';
import ToolbarContainer_s from 'components/subnav/toolbar-styles';
import { TableSearchHeader_s } from 'components/table/search-header';
import styled from "styled-components";
import { Colors } from "styles/app-styles";

export const Help_s = styled.a`
  background: ${Colors.denim};
  border-radius: 100%;
  bottom: 25px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  cursor: pointer;
  height: 50px;
  right: 25px;
  position: fixed;
  width: 50px;
  z-index: 99;
  svg {
    height: 30px;
    margin: 10px;
    width: 30px;
    .r-svg { fill: ${Colors.white}; }
  }
`

export const Main_s = styled.main`
  padding-left: 90px;
  padding-top: ${props => props.summaryBarOpen ? '130px': '80px'};
  width: 100%;
  z-index: 1;
  // Adjust all our lovely fixed containers when the property summary bar is open
  ${FolderExplorerContainer}{
    height: ${props => props.summaryBarOpen ? 'calc(100% - 200px)': 'calc(100% - 150px)'};
  }
  ${SubnavContainer_s}{
    top: ${props => props.summaryBarOpen ? '130px': '80px'};
  }
  ${TableSearchHeader_s}{
    top: ${props => props.summaryBarOpen ? '172px': '122px'};
  }
  ${ToolbarContainer_s}{
    top: ${props => props.summaryBarOpen ? '170px': '120px'};
  }
  .folder-permissions-toolbar {
    top: ${props => props.summaryBarOpen ? '294px !important': '244px !important'};
  }
`

export const SummaryBar_s = styled.details`
  align-items: start;
  background: ${Colors.white};
  border-top: 1px solid ${Colors.towerGrey};
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50px;
  width: 100%;
  z-index: 5;

  summary {
    background: ${Colors.inputFocus};
    cursor: pointer;
    font-size: 14px;
    line-height: 30px;
    padding: 0 15px;
    width: 100%;
    > div {
      background: ${Colors.blackPearl};
      border-radius: 2px;
      color: ${Colors.white} !important;
      cursor: pointer;
      font-size: 14px;
      height: 20px;
      line-height: 14px;
      padding: 3px 8px;
      text-align: center;
      width: 140px;
    }
  }
`

export const SummaryBarDetails_s = styled.div`
  background: ${Colors.white};
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  height: 50px;
  width: 100%;
  padding: 5px 15px;
  box-sizing: border-box;

  > div {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    margin-right: 20px;

    label {
      font-weight: 500;
      line-height: 20px;
    }
  }
`
